import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { products } from '../../data/products';
import { ProductCard } from '../ProductCard';
export function ShopPreview() {
  return <section className="border-t border-ink-950/8 bg-canvas py-20 lg:py-28" data-id="element-151" data-mp="3pcdgcts8bok">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-152" data-mp="3vv988jcnzras">
        <div className="flex flex-col gap-6 sm:flex-row sm:items-end sm:justify-between" data-id="element-153" data-mp="3vsn1un1ifhu5">
          <div className="max-w-xl" data-id="element-154" data-mp="3qta2x3xd6kb7">
            <p className="mb-4 text-xs uppercase tracking-[0.18em] text-aqua-600" data-id="element-155" data-mp="3lvqr0ao52jmf">
              Shop
            </p>
            <h2 className="font-display text-3xl font-semibold leading-[1.08] tracking-tightest text-ink-950 sm:text-4xl lg:text-[46px]" data-id="element-156" data-mp="3gy8eybetroa7">
              Pick your body of water. Text for the price.
            </h2>
            <p className="mt-5 text-base leading-relaxed text-ink-700" data-id="element-157" data-mp="1f4iybqxp029j">
              Florida residents are now eligible for the concierge membership
              program.
            </p>
          </div>
          <Link to="/shop" className="group inline-flex shrink-0 items-center gap-2 text-sm font-medium text-ink-950 transition-colors duration-150 ease-smooth hover:text-aqua-700" data-id="element-158" data-mp="31ua89dhfrk00">
            See all four systems
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-smooth group-hover:translate-x-0.5" aria-hidden="true" data-id="element-159" data-mp="2wwigqkkpdzwc" />
          </Link>
        </div>

        <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3" data-id="element-160" data-mp="3plz5n8946ynt">
          {products.slice(0, 3).map(product => <ProductCard key={product.id} product={product} data-id="element-161" data-mp="3bt9l7898i1st" />)}
        </div>
      </div>
    </section>;
}